/**
 * Cart Page - Quantity Buttons Fix
 * Ensures +/- buttons work correctly on cart page
 */
(function () {
  "use strict";

  // Flag to track if handler is processing
  var isProcessing = false;

  function initCartQuantity() {
    // Completely override by capturing at capture phase (runs before bubble phase)
    document.addEventListener(
      "click",
      function (e) {
        // Check if click is on quantity button
        var target = e.target;
        if (!target.classList.contains("qty-ctl")) {
          return;
        }

        // Check if it's inside .pro-qty
        var proQty = target.closest(".pro-qty");
        if (!proQty) {
          return;
        }

        // ✅ ONLY handle cart page inputs (name="updates[]")
        var $button = $(target);
        var $input = $button.siblings('input[name="updates[]"]');

        // If no cart input found, let other handlers process it (product detail page)
        if (!$input.length) {
          return; // Don't stop propagation - let it bubble to other handlers
        }

        // ✅ Only stop propagation if this is a cart page input
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Prevent double processing
        if (isProcessing) {
          return false;
        }
        isProcessing = true;

        var currentQty = parseInt($input.val(), 10) || 1;
        var isIncrement = $button.hasClass("inc");
        var newQty = currentQty + (isIncrement ? 1 : -1);

        // Ensure minimum quantity is 1
        if (newQty < 1) newQty = 1;

        // Get inventory limit from totalqty attribute
        var maxQty = parseInt($input.attr("totalqty"), 10);

        // Apply inventory limit if tracked (totalqty > 0)
        if (!isNaN(maxQty) && maxQty > 0 && newQty > maxQty) {
          newQty = maxQty;
        }

        // Apply Shopify cart quantity limit
        var cartLimit = window.cartQuantityLimit || 999;
        if (cartLimit && newQty > cartLimit) {
          newQty = cartLimit;
        }

        // Update input value
        $input.val(newQty);

        // Trigger change event for cart update
        setTimeout(function () {
          $input.trigger("change");
          isProcessing = false;
        }, 50);

        return false;
      },
      true
    ); // TRUE = capture phase (runs BEFORE other handlers)

    // Handle direct input change
    $(document).on("change", '.pro-qty input[name="updates[]"]', function () {
      var $input = $(this);
      var value = parseInt($input.val(), 10) || 1;
      var maxQty = parseInt($input.attr("totalqty"), 10);

      // Ensure minimum is 1
      if (value < 1) value = 1;

      // Apply inventory limit if tracked
      if (!isNaN(maxQty) && maxQty > 0 && value > maxQty) {
        value = maxQty;
      }

      // Apply cart limit
      var cartLimit = window.cartQuantityLimit || 999;
      if (cartLimit && value > cartLimit) {
        value = cartLimit;
      }

      $input.val(value);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartQuantity);
  } else {
    initCartQuantity();
  }

  // Also initialize on jQuery ready (for compatibility)
  $(document).ready(function () {
    initCartQuantity();
  });
})();
